import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle } from 'lucide-react';
export function ProblemSolutionSection() {
  return <section className="py-20 bg-[#F9F4EF] px-4 sm:px-6 lg:px-8 relative" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-110">
          {/* Problem Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-[#D4A5A5]/20" data-id="element-111">
            <h3 className="text-2xl font-serif font-bold text-[#5C4033] mb-6 flex items-center gap-3" data-id="element-112">
              <XCircle className="text-[#D4A5A5]" data-id="element-113" />
              El Problema Moderno
            </h3>
            <p className="text-[#6B5A4D] mb-4" data-id="element-114">
              Hoy estamos rodeadas de productos caros, soluciones artificiales y
              promesas que no cumplen. Para cada problema cotidiano parece que
              hay que comprar algo nuevo.
            </p>
            <ul className="space-y-3" data-id="element-115">
              <li className="flex items-start gap-3 text-[#6B5A4D]" data-id="element-116">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D4A5A5] mt-2 flex-shrink-0" data-id="element-117" />
                Dolores comunes y malestares diarios.
              </li>
              <li className="flex items-start gap-3 text-[#6B5A4D]" data-id="element-118">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D4A5A5] mt-2 flex-shrink-0" data-id="element-119" />
                Problemas simples que se vuelven complejos.
              </li>
              <li className="flex items-start gap-3 text-[#6B5A4D]" data-id="element-120">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D4A5A5] mt-2 flex-shrink-0" data-id="element-121" />
                Soluciones químicas y costosas.
              </li>
            </ul>
          </motion.div>

          {/* Solution Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#9CAF88]/10 p-8 rounded-2xl border border-[#9CAF88]/30" data-id="element-122">
            <h3 className="text-2xl font-serif font-bold text-[#5C4033] mb-6 flex items-center gap-3" data-id="element-123">
              <CheckCircle className="text-[#9CAF88]" data-id="element-124" />
              La Sabiduría de la Abuela
            </h3>
            <p className="text-[#5C4033] mb-4" data-id="element-125">
              Mientras tanto, durante años, las abuelas resolvieron todo con lo
              que tenían en casa. Con experiencia. Con lógica. Con conocimiento
              real.
            </p>
            <p className="text-[#5C4033] mb-4 italic" data-id="element-126">
              El problema no es que esas soluciones no existan. El problema es
              que nadie las reunió, explicó y ordenó para la vida actual.
            </p>
            <div className="mt-6 p-4 bg-[#FFF8F0] rounded-lg border border-[#9CAF88]/20" data-id="element-127">
              <p className="font-serif font-bold text-[#5C4033]" data-id="element-128">
                El Manual Secreto de la Abuela 2.0 recupera esa sabiduría
                práctica y la transforma en una guía clara, moderna y fácil de
                aplicar.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}